import FormTable from './FormTable/FormTable.react';
import React from 'react';

let TokensTable = ({ certs, onDelete, uploadPending }) => {
  let tableData = certs.map(c => {
    return {
      title: c.bundle,
      onDelete: onDelete.bind(null, c.id),
      color: "green",
      production: c.production,
      notes: [
        {
          key: 'Type',
          value: "Apple Push Services",
          strong: true,
        },
        {
          key: 'Key ID',
          value: c.key_id,
        },
        {
          key: 'Team ID',
          value: c.team_id,
        }
      ]
    };
  });

  if (uploadPending) {
    tableData.unshift({
      title: 'Processing File\u2026',
      color: 'blue',
      notes: [
        {
          key: 'Type',
          value: 'Apple Push Services',
          strong: true,
        }
      ],
    });
  }
  return <FormTable items={tableData} />
};

export default TokensTable;
